import { AppUIBrackPoint, AppUIDevice } from "../types/ui-sytem.type";

export function getScreenAppUIBrackPoint(screenWidth: number): AppUIBrackPoint {

    //const screenWidth = window.innerWidth;

    if (screenWidth <= 576) {

        return 'SM';
    } else if (screenWidth <= 768) {

        return 'MD';
    } else if (screenWidth <= 992) {

        return 'LG';
    } else if (screenWidth <= 1200) {

        return 'XL';
    }

    return 'XXL';
}

export function getAppUIDevice(screenWidth: number): AppUIDevice {

    if (screenWidth <= 576) {

        return 'SMART_PHONE_SIZE';
    } else if (screenWidth <= 768) {

        return 'TABLET_SIZE';
    } else if (screenWidth <= 992) {

        return 'SMALL_DESKTOP_SIZE';
    } else if (screenWidth <= 1200) {

        return 'DESKTOP_SIZE';
    }

    return 'DESKTOP_SIZE';
}